import {createSelector} from 'reselect';
import props from '../../../selectors/props'

export default createSelector(
    props.user.user,
    props.app.notify,
    (user, notify) => {
        return {
            user,
            notify
        }
    }
)